<div class="promo-text-modal" *transloco="let t">
  <div class="modal-header">
    <span class="modal-title"><strong>{{ t('promo-text-edit-modal.title') }}</strong></span>
    <div class="info-icon"
         [matTooltip]="t('promo-text-card-tooltip')">
      <nb-icon icon="info-outline"></nb-icon>
    </div>
  </div>
  <div class="modal-divider"></div>
  <div class="modal-body">
    <app-input [label]="t('promo-text-en-Label')"
               [control]="getControlByLang('en')">
    </app-input>
    <app-input [label]="t('promo-text-es-Label')"
               [control]="getControlByLang('es')">
    </app-input>
    <app-input [label]="t('promo-text-pt-Label')"
               [control]="getControlByLang('pt')">
    </app-input>
  </div>
  <div class="modal-footer">
    <app-primary-button stroked (clickAction)="clickCancel()">{{ t('cancel') }}</app-primary-button>
    <app-primary-button
      (clickAction)="clickSave()"
      [disabled]="form.invalid">
      {{ t('save-changes') }}
    </app-primary-button>
  </div>
</div>
